<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    Conformidade Técnica
                </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-erros-box
                        :erros="erros"
                        v-if="erros.length > 0"
                    ></app-erros-box>
                    <app-tabela
                        :itens="conformidadesTecnicas"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false">
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-reprovar-conformidade-tecnica
                                v-if="conformidadesTecnicas.length < 1"
                                :pleito="pleito"
                                class="mr-2"
                                :dataServicos="dataServicos"
                                @atualizarLista="atualizarLista()">
                            </btn-reprovar-conformidade-tecnica>
                        </b-button-group>
                        <b-button-group class="float-right">
                            <btn-aprovar-conformidade-tecnica
                                v-if="conformidadesTecnicas.length < 1"
                                :pleito="pleito"
                                class="mr-2"
                                :dataServicos="dataServicos"
                                @atualizarLista="atualizarLista()">
                            </btn-aprovar-conformidade-tecnica>
                        </b-button-group>
                    </template>
                    <template slot="justificativa" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.justificativa }}
                        </p>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <div class="flex flex-row">
                            <span>
                                <documentos-conformidade-tecnica
                                    :conformidadeTecnica="data"
                                    :pleito="pleito"
                                    :servicos="dataServicos"
                                    @atualizarLista="atualizarLista()">
                                </documentos-conformidade-tecnica>
                            </span>
                        </div>
                    </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>
    
<script>
import BtnAprovarConformidadeTecnica from './BtnAprovarConformidadeTecnica'
import BtnReprovarConformidadeTecnica from './BtnReprovarConformidadeTecnica'
import DocumentosConformidadeTecnica from './DocumentosConformidadeTecnica'

export default {
    components: {
        BtnAprovarConformidadeTecnica,
        BtnReprovarConformidadeTecnica,
        DocumentosConformidadeTecnica
    },

    props: {
        dataServicos: {
            type: Object
        },
        pleito: {
            type: Object,
        },
        pleitoConformidadeTecnica: {
            type: Array,
        }
    },

    data() {
        return {
            erros: [],
            conformidadesTecnicas: [],
            conformidadeTecnica:null,
            itensPorPagina: 5,
            campos: [
                {
                    key: 'justificativa',
                    label: 'Justificativa',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],

        }
    },

    methods:{
        atualizarLista() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterConformidadesTecnicas(this.$route.params.pleitoId).then((response) => {
            if (response) {
                if (response.success) {
                    this.conformidadesTecnicas = response.data
                    this.$emit('atualizarConformidadeTecnica')
                } else {
                    this.erros = response.errors
                }
            }
            this.$store.dispatch('removeRequest')
            })
        },
    },
    mounted() {
        this.conformidadesTecnicas = this.pleitoConformidadeTecnica
    }
}
</script>
